<template>
	<div class="partner-info">
		<loading v-if="loading"></loading>
		<div v-else class="is-flex">
			<router-link v-if="partnerProfileRoute" :to="partnerProfileRoute"></router-link>
			<user-picture
				:user="activeUser"
				size="large"
				v-if="activeUser"
				@click="navigateToPartnerProfile"
				class="clickable"></user-picture>
			<div v-if="activeUser" class="is-flex is-flex-direction-column">
				<div class="mt-2">
					<h3>{{ activeUser.FirstName }} {{ activeUser.LastName }}</h3>
					<div>{{ activeUser.Title }}</div>
					<div>
						<div v-for="location in activeUser.Locations" :key="location.Id">
							{{ location.Name }}
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div>
						<!-- {{ activeUser.OfficePhone }} -->
						<a :href="'tel:' + activeUser.OfficePhone">{{ activeUser.OfficePhone }}</a>
					</div>
					<div>
						<a :href="'mailto:' + activeUser.Email" v-html="FormatEmail(activeUser.Email)"></a>
						<!-- {{ activeUser.Email }} -->
					</div>
				</div>
			</div>
			<div v-else>
				<skeleton-detail></skeleton-detail>
			</div>
		</div>
	</div>
</template>
<script>
	import { computed, inject, ref } from "vue";
	import { useRouter } from "vue-router";
	import { skeletonDetail } from "@/components/webComponents/template";
	export default {
		components: {
			skeletonDetail
		},
		props: {
			userId: {
				type: [String, Number],
				default: undefined
			},
			user: {
				type: Object,
				default: () => {
					return undefined;
				}
			}
		},
		setup(props, context) {
			const $http = inject("$http");
			const router = useRouter();

			const loading = ref(true);

			const FormatEmail = (email) => {
				if (!email) return "";
				const parts = email.split("@");
				return parts[0] + "<wbr>@" + parts[1];
			};

			const activeUser = ref(props.user);

			const partnerProfileId = computed(() => {
				return props.userId || props.user?.ID || props.user?.Id || activeUser.value?.ID || activeUser.value?.Id;
			});

			const partnerProfileRoute = computed(() => {
				if (!partnerProfileId.value) return null;
				return { name: "_partnerProfile", params: { Id: partnerProfileId.value } };
			});

			const navigateToPartnerProfile = () => {
				if (!partnerProfileRoute.value) return;
				router.push(partnerProfileRoute.value);
			};

			if (!props.user) {
				loading.value = true;
				$http.get("/api/v2/partner/" + props.userId + "/new").then((resp) => {
					activeUser.value = resp.data;
					loading.value = false;
				});
			}

			return {
				loading,
				FormatEmail,
				activeUser,
				navigateToPartnerProfile,
				partnerProfileRoute
			};
		}
	};
</script>

<style scoped>
	.clickable {
		cursor: pointer;
	}
</style>
